<div class="ctm-tab custom-card">
  <div class="modal-body p-0">
    <div class="card text-center">
      <div class="bg-warning p-3">
        <i class="fa fa-exclamation-triangle fa-5x m-auto text-white" aria-hidden="true"></i>
      </div>
      <div class="p-5">
        <h2 class="title18 text-primary lh-base" *ngIf="!isKeyExpired">Your license key will expire on <strong>{{licenseKeyExpirationDate | date: 'shortDate'}}</strong>,<br>
          please contact
          AutoFacets.</h2>
        <h2 class="title18 text-primary lh-base" *ngIf="isKeyExpired">Your license key is expired on <strong>{{licenseKeyExpirationDate | date: 'shortDate'}}</strong>,<br>
          please contact
          AutoFacets.</h2>
      </div>
      
    </div>
  </div>
</div>

<div class="p-3" >
  <div class="row">
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
      <a (click)="OnClose()" *ngIf="!isKeyExpired" class="btn btn-secondary btn-lg" translate>OK</a>
      <a (click)="logOutUser()" *ngIf="isKeyExpired" class="btn btn-secondary btn-lg" translate>lblClose</a>
    </div>
  </div>
</div>